






















































































import AppCard from '~/components/AppCard.vue'
import Vue from 'vue'
import { Role } from '~/../shared/Role'

export default Vue.extend({
  components: {
    AppCard,
  },
  data: () => ({
    title: 'Users',
    invitedUsers: [],
    invitedUsersBackup: [],
    headers: [
      { text: 'First Name', value: 'appUser.firstName' },
      { text: 'Last Name', value: 'appUser.lastName' },
      {
        text: 'Email',
        align: 'start',
        value: 'email',
      },
      { text: 'Status', value: 'userInvite.expired' },
    ],
    clinicalTrials: [],
    centers: [],
    Role,
  }),
  created() {
    this.loadInvitedUsers()
    this.loadClinicalTrials()
    this.loadCenters()
  },
  methods: {
    async loadInvitedUsers() {
      try {
        let res = { data: {} }
        if (this.$auth.user?.role === Role.Admin) {
          res = await this.$axios.get(`user/all`)
        } else {
          res = await this.$axios.get(`user/invited`)
        }
        this.invitedUsers = JSON.parse(JSON.stringify(res.data))
        //make a deep copy for backup
        this.invitedUsersBackup = JSON.parse(JSON.stringify(res.data))
      } catch (e) {
        this.$toast.error('Unable to load invited users.')
      }
    },
    async loadClinicalTrials() {
      let res = await this.$axios.get(`clinical-trial/all`)
      this.clinicalTrials = res.data
    },
    async loadCenters() {
      try {
        const res = await this.$axios.get(`center`)
        this.centers = res.data
      } catch (e) {
        this.$toast.error('Unable to load all centers.')
      }
    },
    async handleModifyTrials(
      inviteId: number,
      userId: number,
      allowedTrials: { id: number; name: string }[]
    ) {
      let userInvite = null as any
      userInvite = this.invitedUsersBackup.find((i: any) => {
        return i.userInvite.id === inviteId
      })
      if (!userInvite) {
        return this.$toast.error('Could not find user-invite')
      } else {
        //find trials newly added
        const newTrials = allowedTrials.filter(
          (x) => !userInvite.allowedTrials.find((e: any) => e.id === x.id)
        )

        //find trials deleted
        const deletedTrials = userInvite.allowedTrials.filter(
          (x: { id: number; name: string }) =>
            !allowedTrials.find((e: any) => e.id === x.id)
        )

        let confirmationText = `Are you sure you want to:\n Add user to trials:\n ${newTrials
          .map((trial) => trial.name + '\n')
          .toString()}\n Remove user from trials:\n ${deletedTrials
          .map((trial: any) => trial.name + '\n')
          .toString()}`
        if (window.confirm(confirmationText)) {
          const body = {
            deletedTrials: deletedTrials.map((x: { id: any }) => x.id),
            addedTrials: newTrials.map((x: { id: any }) => x.id),
          }
          await this.$axios.post(
            `/clinical-trial/changeUserAllowedTrials/${userId}`,
            body
          )
          this.invitedUsersBackup = JSON.parse(
            JSON.stringify(this.invitedUsers)
          )
        }
      }
    },
    async handleModifyCenters(
      inviteId: number,
      userId: number,
      allowedCenters: { id: number; name: string }[]
    ) {
      let userInvite = null as any
      userInvite = this.invitedUsersBackup.find((i: any) => {
        return i.userInvite.id === inviteId
      })
      if (!userInvite) {
        return this.$toast.error('Could not find user-invite')
      } else {
        //find centers newly added
        const newCenters = allowedCenters.filter(
          (x) => !userInvite.centers.find((e: any) => e.id === x.id)
        )

        //find centers deleted
        const deletedCenters = userInvite.centers.filter(
          (x: { id: number; name: string }) =>
            !allowedCenters.find((e: any) => e.id === x.id)
        )

        let confirmationText = `Are you sure you want to:`
        if (newCenters.length > 0) {
          confirmationText += `\n Add user to Centers:\n ${newCenters
            .map((trial) => trial.name + '\n')
            .toString()}`
        }
        if (deletedCenters.length > 0) {
          confirmationText += `\n Remove user from Centers:\n ${deletedCenters
            .map((trial: any) => trial.name + '\n')
            .toString()}
          \nNote that removing user from a center will also remove them from the trials they have been added to as a member of that center.`
        }
        if (window.confirm(confirmationText)) {
          const body = {
            deletedCenters: deletedCenters.map((x: { id: any }) => x.id),
            addedCenters: newCenters.map((x: { id: any }) => x.id),
          }
          await this.$axios.post(
            `/center/changeUserAllowedCenters/${userId}`,
            body
          )
          this.invitedUsersBackup = JSON.parse(
            JSON.stringify(this.invitedUsers)
          )
        }
      }
    },
    async toggleRole(invite: any, role: string) {
      try {
        await this.$axios.get(`user/changeUserRole/${invite.appUser.id}/${role}`)
      } catch (e) {
        this.$toast.error(`Error setting user role.`)
      }
    },
    handleClickUsersYouInvited() {
      this.$router.push(`invited-users`)
    },
  },
})
